import { useFeatureFlagEnabled } from 'posthog-js/react';

import Button from '@/components/Buttons/Button';
import LoadingPage from '@/components/LoadingPage';
import { PERSONALIZATION_FLAG } from '@/constants/featureFlags';
import Dashboard from '@/features/Dashboard';
import NotFound from '@/pages/NotFound';

import { ComponentVariant, PossibleVariants } from './types';

const makeVariants = <T extends { [K in PossibleVariants]: ComponentVariant }>(variants: T) =>
  variants;

const PersonalizationComponentVariants = (props: any) =>
  makeVariants({
    dashboard_button: {
      A: () => <Button {...props}>Add to dashboard</Button>,
      B: () => null
    },

    dashboard_route_element: { A: () => <Dashboard />, B: () => <Dashboard /> }
  });
const PersonalizationVariantRenderer = <T extends { componentName: PossibleVariants }>({
  componentName,
  ...props
}: T) => {
  const isPersonalizationEnabled = useFeatureFlagEnabled(PERSONALIZATION_FLAG);

  const componentVariant = PersonalizationComponentVariants(props)[componentName];

  if (isPersonalizationEnabled === undefined) return <LoadingPage />;

  const Component = isPersonalizationEnabled ? componentVariant.A : componentVariant.B;

  return Component ? <Component /> : null;
};
export default PersonalizationVariantRenderer;
